import React from "react";
import { Field } from "@design-system/Field/Field";
import { Input } from "@design-system/Input/Input";
import { Picker } from "@design-system/Picker/Picker.lib";
import { BaseFilterProps } from "@components/pageHeader/filters/lib";
import styles from "./DaysInStageFilter.module.scss";

type Operator = "gt" | "lt" | "eq" | "between";

const OPERATOR_OPTIONS: Array<{ value: Operator; label: string }> = [
    { value: "gt", label: "Greater than" },
    { value: "lt", label: "Less than" },
    { value: "eq", label: "Equal to" },
    { value: "between", label: "Between" },
];

export const DaysInStageFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const operator = filters.daysInStageOperator;
    const min = filters.daysInStageMin;
    const max = filters.daysInStageMax;

    return (
        <div className={styles.container}>
            <Picker.Select
                items={OPERATOR_OPTIONS}
                value={operator ?? null}
                onValueChange={(value) => {
                    if (!value) {
                        return;
                    }
                    onChange({
                        daysInStageOperator: value,
                        daysInStageMin: undefined,
                        daysInStageMax: undefined,
                    });
                }}
                placeholder="Select operator"
                trigger={
                    <Picker.Button
                        variant="primary"
                        size="xl"
                        block
                        className="mb-3"
                    />
                }
            />

            {operator && operator !== "between" && (
                <Field label="Days" className={styles.textField}>
                    <Input
                        type="number"
                        size="xl"
                        value={min !== undefined ? String(min) : ""}
                        onChange={(event) => {
                            const parsed = parseInt(event.target.value, 10);
                            onChange({
                                daysInStageMin: isNaN(parsed)
                                    ? undefined
                                    : Math.max(0, parsed),
                            });
                        }}
                    />
                </Field>
            )}

            {operator === "between" && (
                <>
                    <Field label="From (days)" className={styles.textField}>
                        <Input
                            type="number"
                            size="xl"
                            value={min !== undefined ? String(min) : ""}
                            onChange={(event) => {
                                const parsed = parseInt(event.target.value, 10);
                                onChange({
                                    daysInStageMin: isNaN(parsed)
                                        ? undefined
                                        : Math.max(0, parsed),
                                });
                            }}
                        />
                    </Field>
                    <Field label="To (days)" className={styles.textField}>
                        <Input
                            type="number"
                            size="xl"
                            value={max !== undefined ? String(max) : ""}
                            onChange={(event) => {
                                const parsed = parseInt(event.target.value, 10);
                                onChange({
                                    daysInStageMax: isNaN(parsed)
                                        ? undefined
                                        : Math.max(0, parsed),
                                });
                            }}
                        />
                    </Field>
                </>
            )}
        </div>
    );
};
